'use client';

import { useState } from "react";

import { CookiePreferencesModal } from "./cookie-preferences-modal";

export function CookiePreferencesLink({ className }: { className?: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        data-testid="footer-cookie-preferences"
        className={className}
        onClick={() => setIsOpen(true)}
      >
        Cookie preferences
      </button>
      {isOpen && <CookiePreferencesModal isOpen onClose={() => setIsOpen(false)} />}
    </>
  );
}
